import { ToastContext } from '#pplx/frontend/aether/toasts/context/ToastContext.js';
import { assertDefined } from '#pplx/frontend/common/type_utils/assertDefined.js';
import { useContext } from 'react';
const MISSING_PROVIDER_ERROR = 'useToastContext must be used within a ToastProvider';
export function useToastContext() {
    const context = useContext(ToastContext);
    assertDefined(context, MISSING_PROVIDER_ERROR);
    return context;
}
//# sourceMappingURL=useToastContext.js.map